import { replaceUrlWithoutRoutePublish } from "../../../../../_shared/_logic/routes-root-silent-url-replace"

export type FlatTableFilterUrlState = {
  filters: Record<string, string>
  mode?: string
}

export type FlatTableFilterUrlDefaults = {
  filters?: Record<string, string>
  mode?: string
}

const normalizeId = (value: string | null | undefined) =>
  (value ?? "").trim().replace(/[^a-zA-Z0-9_-]+/g, "_")

const key = (stateId: string, name: string) => `table_${stateId}_filter_${name}`

const replaceUrl = (params: URLSearchParams) => {
  if (typeof window === "undefined") return

  const nextSearch = params.toString()
  const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ""}${window.location.hash ?? ""}`
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash ?? ""}`

  if (nextUrl !== currentUrl) {
    replaceUrlWithoutRoutePublish(nextUrl)
  }
}

export const readFlatTableFilterUrlState = (
  stateId: string | null | undefined,
  filterKeys: string[],
): FlatTableFilterUrlState => {
  const id = normalizeId(stateId)

  if (typeof window === "undefined" || !id) return { filters: {} }

  const params = new URLSearchParams(window.location.search || "")
  const filters: Record<string, string> = {}
  for (const filterKey of filterKeys) {
    filters[filterKey] = params.get(key(id, filterKey)) ?? ""
  }

  return {
    filters,
    mode: params.get(key(id, "mode")) ?? "",
  }
}

export const writeFlatTableFilterUrlState = (
  stateId: string | null | undefined,
  state: FlatTableFilterUrlState,
  defaults: FlatTableFilterUrlDefaults = {},
) => {
  const id = normalizeId(stateId)

  if (typeof window === "undefined" || !id) return

  const params = new URLSearchParams(window.location.search || "")
  for (const [filterKey, value] of Object.entries(state.filters)) {
    const normalized = `${value ?? ""}`.trim()
    const defaultValue = `${defaults.filters?.[filterKey] ?? ""}`.trim()

    if (normalized && normalized !== defaultValue) {
      params.set(key(id, filterKey), normalized)
    } else {
      params.delete(key(id, filterKey))
    }
  }
  const defaultMode = defaults.mode ?? "compact"

  if (state.mode && state.mode !== defaultMode) {
    params.set(key(id, "mode"), state.mode)
  } else {
    params.delete(key(id, "mode"))
  }

  replaceUrl(params)
}
